import type { MessageKeys } from 'next-intl';
import type { InferV1CreationTaskInfo } from '../types';

export const MAX_TREE_DEPTH = 5;
export const MAX_SELECT_ITEMS = 99;

// 路由路径常量
export const ROUTE_PATHS_MY_CREATIONS = '/assets/mycreations';

/** 类型转国际化key */
export const CREATION_TYPE_TO_I18N_KEY: Record<
  Required<InferV1CreationTaskInfo>['type'],
  MessageKeys<
    IntlMessages,
    'creations.filters.fileTypes.video' | 'creations.filters.fileTypes.audio' | 'creations.filters.fileTypes.image'
  >
> = {
  image: 'creations.filters.fileTypes.image',
  video: 'creations.filters.fileTypes.video',
  audio: 'creations.filters.fileTypes.audio',
  mini_video: 'creations.filters.fileTypes.video',
  unspecified: 'creations.filters.fileTypes.video',
};
/** 类型转文件扩展名 */
export const CREATION_TYPE_TO_FILE_EXTENSION: Record<Required<InferV1CreationTaskInfo>['type'], string> = {
  image: 'png',
  video: 'mp4',
  audio: 'wav',
  unspecified: 'mp4',
  mini_video: 'mp4',
};

export const FILTER_OPTION_VALUES = {
  fileTypes: {
    video: 'video',
    audio: 'audio',
    folder: 'folder',
    image: 'image',
  },
  taskTypes: {
    referenceToVideo: 'character2video',
    imageToVideo: 'img2video',
    textToVideo: 'text2video',
    textToImage: 'text2image',
    templates: 'scene',
    upscale: 'upscale',
    referenceToImage: 'reference2image',
    auto2video: 'auto2video',
    remix2video: 'remix2video',
    extend: 'extend',
    videoEdit: 'video_edit',
    clipCompose: 'clip_compose',
    imageEdit: 'image_edit',
    faceSwap: 'face_swap',
    oneClick: 'one_click',
    remake: 'remake',
    upscale_image: 'upscale_image',
    musicVideo: 'music_video',
    lipSync: 'lip_sync',
    tts: 'tts',
    offlineAvatar: 'offline_avatar',
    storyGrid: 'short_story',
    styleTransfer: 'style_transfer',
    motionControl: 'motion_control',
    characterCreation: 'character_creation',
  },
  resolutions: {
    '4k': 'Resolution_4k',
    '2k': 'Resolution_2k',
    '1080p': 'Resolution_1080p',
    '720p': 'Resolution_720p',
    speed: 'Resolution_speed',
    other: 'Resolution_other',
  },
  ratios: {
    '16:9': 'Ratio_16_9',
    '9:16': 'Ratio_9_16',
    '1:1': 'Ratio_1_1',
    '4:3': 'Ratio_4_3',
    '3:4': 'Ratio_3_4',
    '21:9': 'Ratio_21_9',
    other: 'Ratio_other',
  },
  modelVersions: {
    q4: 'V_q4',
    q3_fast: 'V_q3_fast_m',
    q3_pro: 'V_q3_pro_m',
    q3_lite: 'V_q3_lite_m',
    q3_a: 'V_q3_a',
    q3_hh: 'V_q3_hh',
    q3: 'V_q3',
    q2Pro: 'V_q2_pro',
    q2: 'V_q2',
    q1: 'V_q1',
    '2.0': 'V_2_0',
    '1.5': 'V_1_5',
    '1.0': 'V_1_0',
    gptImage2: 'V_q3_image_2',
    gptImage25Fast: 'V_q3_image_2_5_fast',
    gptImage25Pro: 'V_q3_image_2_5_pro',
  },
} as const;
